import { useQuery, useQueryClient } from '@tanstack/react-query'
import * as RouteKeys from '../reactQueryKeys/routes'
import type { TravelMode } from 'tripPlanner/api/routes/getRouteInfo'

export const useRouteDirections = (
  origin?: { lat: number, lng: number },
  destination?: { lat: number, lng: number },
  travelMode?: TravelMode,
) => {
  const queryClient = useQueryClient()
  const key = RouteKeys.routeDirectionsQueryKey(origin, destination, travelMode)

  return useQuery<Array<google.maps.LatLngLiteral>>({
    queryKey: key,
    enabled: !!origin && !!destination && !!travelMode,
    staleTime: 30 * 60 * 1000,
    cacheTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    initialData: () => queryClient.getQueryData<Array<google.maps.LatLngLiteral>>(key),
    queryFn: async() => queryClient.getQueryData<Array<google.maps.LatLngLiteral>>(key) ?? [],
  })
}
